<template>
  <div>
    <span :class="'state' + Field.Value" v-if="Field">{{ Field.Title }}</span>
    <span class="'state1'" v-else> 未配置参数</span>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    config: Object,
    theme: String
  },
  computed: {
    Field() {
      if (this.value) { 
        if (typeof this.value[this.theme] === 'object') {
          return {
            Title: this.value[this.theme].Name,
            Value: this.value[this.theme].Id || 1
          }
        } else if (typeof this.value[this.theme] === 'boolean') {
          return {
            Title: this.value[this.theme] ? '是' : '否',
            Value: this.value[this.theme] ? '1' : '2'
          }
        } else {
          let Field = this.$matrix.Models[this.config.Type].Fields.find((item) => {
            return item.Name === this.theme
          })
          if (Field) {
            let res = Field.Options.find((opt) => {
              return opt.Value === this.value[this.theme]
            })
            return res
          }
        }
      }
      return null
    }
  }
}
</script>
<style scoped>
.active {
  color: #2d8cf0;
}

.state1,
.state2,
.state3,
.state4,
.state5,
.state6,
.state7,
.state8,
.state9,
.state10,
.state11,
.state12 {
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
}

.state1 {
  background: #999999;
}

.state2 {
  background: #ff8f1f;
}

.state3 {
  background: #118dff;
}

.state4 {
  background: #2a8446;
}

.state5 {
  background: #9f1c4b;
}

.state6 {
  background: #821cad;
}

.state7 {
  background: #d0e83f;
}

.state8 {
  background: #6fae3b;
}

.state9 {
  background: #409eff;
}

.state10 {
  background: #3594cc;
}

.state11 {
  background: #821cad;
}

.state12 {
  background: #6fae3b;
}
</style>
